import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IdentityConfigurationService } from '@identity/identity-configuration.service';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    private identityConfigService: IdentityConfigurationService = inject(IdentityConfigurationService);

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        //const authToken = this.auth.getAuthorizationToken();
        const client = this.identityConfigService.getClient();
        const product = req.headers.get('x-product') || this.identityConfigService.getProduct();
        const service = req.headers.get('x-service') || this.identityConfigService.getService();
        const subscription = req.headers.get('x-subscription-key') || this.identityConfigService.getConfiguration('SUBSCRIPTION_KEY');

        let newReq = req.clone({
            headers: req.headers.set('x-client', client)
                .set('x-product', product)
                .set('x-service', service)
                .set('Accept-Language', localStorage.getItem('lng') ?? 'en')
                .set('x-subscription-key', subscription)
        })

        return next.handle(newReq);
    }
}
